import styled from 'styled-components';
import { Image } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Segment as SegmentLayoutComponent, Text as TextLayoutComponent,
  Loader as LoaderComponent,
  Checkbox as CheckboxLayoutComponent,
} from '@playbookux/playbook-web-core';

const Container = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  margin-left: auto;
  margin-right: auto;
  max-width: 570px;
  display: flex;
`;

const FormContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
  width: 100%;
`;

const Header = styled(TextLayoutComponent.Header)`
  font-weight: 500;
  margin-bottom: 5px;
`;

const TextStatusError = styled(TextLayoutComponent)`
  font-size: 18px;
`;

const SegmentTitle = styled(TextLayoutComponent.Bold)``;

const ErrorMessage = styled(TextLayoutComponent.Error)`
  margin-bottom: 10px;
`;

const Text = styled(TextLayoutComponent)``;

const ContextSegment = styled(SegmentLayoutComponent)`
  &&& {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    margin-top: 40px;
    padding: 20px;
    width: 570px;
  }
`;

const TaskSegment = styled(SegmentLayoutComponent)`
  &&& {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    margin: 20px 0;
    padding: 20px;
    width: 570px;
  }
`;

const UrlContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
`;

const InputContainer = styled.div`
  flex: 2;
  margin-left: 20px;
`;

const HeaderSegmentContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${({ noSpace }) => !noSpace && 'justify-content: space-between'};
  align-items: center;
  margin-bottom: 10px;
`;

const InstructionsContainer = styled.div`
  margin-bottom: 10px;
`;

const AddTask = styled.div`
  margin: 30px 0 0 10px;
`;

const Add = styled.a`
  cursor: pointer;
`;

const Checkbox = styled(CheckboxLayoutComponent)`
  &&& {
    margin: 10px 5px;
  }
`;

const RateTaskCheckbox = styled(CheckboxLayoutComponent)`
  &&& {
    margin-left: 5px;
  }
`;

const CustomIcon = styled(Image)`
  &&& {
    cursor: pointer;
    height: 20px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
`;

const SubmitButton = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 125px;
  }
`;

const CancelButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-right: 60px;
    width: 125px;
  }
`;

const BackButton = styled.a`
  cursor: pointer;
  font-size: 16px;
  left: 5%;
  position: absolute;
  top: 100px;
`;

const NewTabIcon = styled.img`
  width: 17px;
  height: 17px;
`;

const ContainerText = styled.div``;

const Link = styled.a`
  display: inline-flex;
  align-items: center;
`;

const Optional = styled(TextLayoutComponent.Optional)`
  margin: 0 5px;
`;

const ContainerSurverPage = styled.div`
  margin-top: 10px;
`;

const Loader = styled(LoaderComponent)``;

const ContainerLoading = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
  margin-top: 2rem;
`;

export {
  Add,
  AddTask,
  BackButton,
  ButtonContainer,
  Checkbox,
  Container,
  ContainerLoading,
  ContextSegment,
  CustomIcon,
  ErrorMessage,
  FormContainer,
  Header,
  HeaderSegmentContainer,
  InputContainer,
  InstructionsContainer,
  SubmitButton,
  RateTaskCheckbox,
  CancelButton,
  SegmentTitle,
  TaskSegment,
  Text,
  TextStatusError,
  UrlContainer,
  NewTabIcon,
  ContainerText,
  Link,
  Loader,
  Optional,
  ContainerSurverPage,
};
